module.exports = __webpack_public_path__ + "static/media/myData.5ccee9a7.svg";